import {
   AfterViewInit,
   Component,
   ElementRef, EventEmitter,
   Input,
   OnInit, Output,
   TemplateRef,
   ViewChild,
} from '@angular/core';
import {AbstractControl, UntypedFormControl} from "@angular/forms";
import {MatAutocomplete, MatAutocompleteTrigger} from "@angular/material/autocomplete";
import {debounceTime, filter, finalize, switchMap, tap} from "rxjs/operators";
import {from, of} from "rxjs";
import {ServerService} from "../../../services/server.service";
import _ from "lodash";

@Component({
   selector: 'app-autocomplete-input',
   styleUrls: ['./autocomplete-input.component.scss'],
   templateUrl: './autocomplete-input.component.html',
})
export class AutocompleteInputComponent implements OnInit, AfterViewInit {

   @ViewChild('trigAutoComplete') triggerAutoComplete!: MatAutocompleteTrigger;
   @ViewChild('autocomp') autocomp!: MatAutocomplete;
   @ViewChild('input', {static: true}) input!:ElementRef;

   @Input() showAdd:boolean = true
   @Input() width:number = 100
   @Input() appearance:any = 'standard'
   @Input() styleForm:any = ''
   @Input() url:string = ''
   @Input() queryParams:string = ''
   @Input() name:string = ''
   @Input() placeholder:string = ''
   @Input() classForm:any = ''
   @Input() withLabel:boolean = true

   @Input() optionTemplate: TemplateRef<any> | null = null;
   @Input() inputCtrl: UntypedFormControl = new UntypedFormControl();
   _inputCtrl: UntypedFormControl = new UntypedFormControl();

   @Input() classObject: any;
   @Input() array:any[] = []

   @Input() displayFn!: (e:any, array:any) => any;

   @Output() outputChoice = new EventEmitter<any>()
   @Output() clickNewElement = new EventEmitter<any>()
   @Output() outputSearched = new EventEmitter<any>()

   isLoading: boolean = false;
   errorMsg: string = '';
   minLengthTerm = 3;
   inSearch = true;

   constructor(private serverSrv: ServerService) {
      if(!this.displayFn){
         this.displayFn = ()=>{
            return ""
         }
      }
   }

   ngOnInit(): void {}

   ngAfterViewInit(): void {
      console.log("autocomplete ngAfterViewInit")
      this.inputCtrl.valueChanges
         .pipe(
            tap(($e)=>{
               if(this.inputCtrl.value != $(this.input.nativeElement).val()){
                  this.isLoading = false;
                  this.inSearch = false
                  return false
               }else{
                  this.inSearch = true
                  this.isLoading = $e;
                  this.array = [];
                  this.errorMsg = "";
                  return true
               }
            }),
            debounceTime(1000),
            filter(res => {

               console.group("filter")
               console.log(this.autocomp)
               console.log(res)
               console.log(this.inputCtrl.value)
               console.groupEnd()

               let ris = res !== null && res.length >= this.minLengthTerm
               if(!ris){
                  // this.errorMsg = 'Nessun elemento trovato';
                  this.errorMsg = '3 caratteri necessari';
                  this.array = []
                  this.isLoading = false;
               }
               return ris
            }),
            switchMap(v=>{
               const key:string = this.queryParams;

               // usando i computed property names racchiudi la variabile tra []
               const qParams = {
                  [key]: v
               };


               console.log(this.inputCtrl.value)
               console.log(this._inputCtrl.value)

               return from( new Promise((resolve, reject) => {
                  this.serverSrv.getAll(this.classObject, this.url, qParams).then(res => {
                     this.array = res
                     this.outputSearched.emit(this.array)
                  }).catch(err => {
                     console.error(err)
                     reject(err)
                  }).finally(()=>{
                     this.isLoading = false
                     resolve(this.array)
                  })
               }))})
         )
         .subscribe((data) => {
            if (this.array.length == 0) {
               this.errorMsg = 'Nessun elemento trovato';
               this.array = []
            } else {
               this.errorMsg = "";
            }
            this.isLoading = false
         });
   }

   outputSelection(e) {
      this.outputChoice.emit(
         [e, this.array]
      )
   }

   clickNew() {
      console.log(this.inputCtrl.value)
      console.log($(this.input.nativeElement).val())
      if(this.inputCtrl.value != $(this.input.nativeElement).val()){
         console.warn("valori uguali")
         return
      }
      this.clickNewElement.emit(this.inputCtrl.value)
      this.input?.nativeElement.blur()
      this.triggerAutoComplete.closePanel()
      this.inputCtrl.value.patchValue('')
   }

   select($event: Event) {
      console.log("select")
   }

   autocompleteClosed() {
      let test = _.parseInt(this.inputCtrl.value)
      if(!_.isInteger(test)){
         this.inputCtrl.reset()
      }
   }

   setText(value){
      $(this.input.nativeElement).val(value)
   }
}
